import { Alert as MuiAlert, Snackbar } from '@mui/material';

type AlertProps = {
  open: boolean;
  autoHideDuration: number;
  severity: 'success' | 'error' | 'warning' | 'info';
  message: string;
  onClose: () => void;
  dataTestId?: string;
};

export const Alert = ({
  severity,
  message,
  open,
  autoHideDuration,
  onClose,
  dataTestId,
}: AlertProps) => {
  return (
    <Snackbar
      data-testid={dataTestId}
      open={open}
      autoHideDuration={autoHideDuration}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      onClose={onClose}
    >
      <MuiAlert onClose={onClose} severity={severity} variant="filled" sx={{ width: '100%' }}>
        {message}
      </MuiAlert>
    </Snackbar>
  );
};
